import axios from 'axios'

const deviceStatusApi = async () => {
  const result = await axios.get(`/devices/status`)
  return result.data.value
}

export default deviceStatusApi